import { createContext, useMemo, useContext, useState, useEffect, useRef, useCallback } from 'react';
import Cookies from 'universal-cookie';
import useToken from '../useToken';
import { HubConnectionBuilder, HttpTransportType } from '@microsoft/signalr';
import { useTokenRenewal } from '../hooks/useTokenRenewal';
import { getRolesFromToken } from '../utils/roles';
import { canAccessView } from '../routes/viewPermissions';

const GeneralContext = createContext();

const setColor = (newColor) => {
    document.documentElement.style.setProperty('--color', newColor);
};

export function GeneralProvider(props) {
    const interval1 = useRef(0);
    const { token, setToken } = useToken();
    let tokenR = useRef(token);
    const [infoUser, setInfoUser] = useState([]);
    const [statusLinea, setStatusLinea] = useState([]);
    const [openM, setOpenM] = useState(false);
    const [isCall, setIsCall] = useState(false);
    const [openP, setOpenP] = useState(false);
    const [openConf, setOpenConf] = useState(false);
    const [llamadas, setLlamadas] = useState([]);
    const [llamada, setLamada] = useState([]);
    const [colorB, setColorB] = useState('');
    const [colorT, setColorT] = useState('');
    const [textC, setTextC] = useState('');
    const [openC, setOpenC] = useState(false);
    const [openUE, setOpenUE] = useState(false);
    const [openIni, setOpenIni] = useState(false);
    const [openIniEsp, setOpenIniEsp] = useState(false);
    const [openTermEsp, setOpenTermEsp] = useState(false);
    const [terminarCorrida, setTerminarCorrida] = useState(false);
    const [tipoMensaje, setTipoMensaje] = useState('success');
    const [mensaje, setMensaje] = useState('');
    const [openSnack, setOpenSnack] = useState(false);
    const [selectParo, setSelectParo] = useState('');
    const [mensajeConf, setMensajeConf] = useState('');
    const [catego, setCatego] = useState('');
    const [folio, setFolio] = useState();
    const [idParo, setIdParo] = useState();
    const [notify, setNotify] = useState(0);
    const [difCajas, setDifCajas] = useState(0);
    const [paros, setParos] = useState([]);
    const [intervalo, setIntervalo] = useState(0);
    const [isLoading, setIsLoading] = useState(false);
    // Bloqueo para evitar disparar RealizarLlamada/ReasignarLlamada más de una vez a la vez.
    // El estado controla el feedback visual; el ref garantiza el bloqueo síncrono ante clics rápidos.
    const [callInProgress, setCallInProgress] = useState(false);
    const callInProgressRef = useRef(false);
    const [inParosView, setInParosView] = useState(false);
    const [confirm, setConfirm] = useState(false);
    const [confirmIni, setConfirmIni] = useState(false);
    const [confirmIniEsp, setConfirmIniEsp] = useState(false);
    const [confirmTermEsp, setConfirmTermEsp] = useState(false);
    const [loadingTable, setIsLoadingTable] = useState(false);
    const [celdas, setCeldas] = useState([]);
    const [areas, setAreas] = useState([]);
    const [infoUE, setInfoUE] = useState([]);
    const [modoCierre, setModoCierre] = useState(2);
    const [openScrap, setOpenScrap] = useState(false);
    const [scrapData, setScrapData] = useState({});
    const [celda, setCelda] = useState(() => parseInt(new Cookies().get('celda')) || 7);
    const [isInParosView, setIsInParosView] = useState(false);
    const [selectedRow,setSelectedRow]=useState(null);
    
    // Flags de inicialización como refs (no globales) para reset correcto en logout/login
    const generalContextInitializedRef = useRef(false);
    const generalContextServicesInitializedRef = useRef(false);

    // Refs para evitar llamadas duplicadas de servicios
    const servicesInitializedRef = useRef(false);
    const lastCeldaRef = useRef(null); // Inicializar como null para detectar primera vez
    const lastIntervaloRef = useRef(null); // Inicializar como null para detectar primera vez
    const llamadasCeldasInitializedRef = useRef(false);
    const lastLlamadasLengthRef = useRef(0);
    const parosStatusInitializedRef = useRef(false);
    
    // Refs para las funciones para evitar dependencias en useEffect
    const getParosRef = useRef(null);
    const getStatusLineaRef = useRef(null);
    const getEnumRef = useRef(null);
    const getLlamadasRef = useRef(null);
    const getCeldasRef = useRef(null);
    const handleClickBRef = useRef(null);
    const isModalOpenRef = useRef(false);

    // Guardas del polling de estatus de línea: evitan peticiones solapadas si el
    // servidor tarda más que el intervalo, y re-renders cuando la data no cambió
    const statusLineaFetchingRef = useRef(false);
    const lastStatusLineaJsonRef = useRef('');

    // Catálogo de paros autorizados; en ref para no recrear getStatusLinea al cargarlo
    const parosAutRef = useRef([]);

    if (process.env.REACT_APP_THEME === 'tecnoTheme') {
        setColor('#eb7d1e');
    } else if (process.env.REACT_APP_THEME === 'colTheme') {
        setColor('#58ab01');
    } else if (process.env.REACT_APP_THEME === 'posTheme') {
        setColor('#118DFF');
    } else if (process.env.REACT_APP_THEME === 'vaisandTheme') {
        setColor('#1959D9');
    } else {
        setColor('#903bff');
    }

    const getLlamadas = useCallback(async () => {
        const data = await fetch(`${process.env.REACT_APP_SERVICE_ENDPOINT_NE}/tiposllamada/Listado`, {
            method: 'GET',
            headers: {
                authorization: `Bearer ${tokenR.current}`,
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
        });

        const calls = await data.json();

        if (data.status !== 400) {
            setLlamadas((prevState) => {
                if (prevState !== calls) {
                    return calls;
                }
                return prevState;
            });
        }
    }, []);

    const getParosAutorizados = useCallback(async () => {
        try {
            const data = await fetch(
                `${process.env.REACT_APP_SERVICE_ENDPOINT_NE}/TiposLlamada/ListadoParosAutorizados`,
                {
                    method: 'GET',
                    headers: {
                        authorization: `Bearer ${tokenR.current}`,
                        Accept: 'application/json',
                        'Content-Type': 'application/json',
                    },
                }
            );
            if (!data.ok) return;
            const paros = await data.json();
            if (Array.isArray(paros)) {
                parosAutRef.current = paros;
            }
        } catch (error) {
            // Error de red: el estatus cae al nombre genérico hasta el siguiente cargue
        }
    }, []);

    // const getParos = async () => {
    //     const cookie = new Cookies();
    //     const data = {
    //         celda: celda,
    //         cantHoras: intervalo,
    //     };

    //     const res = await fetch(`${process.env.REACT_APP_SERVICE_ENDPOINT_NE_NE}/api/Paros/GetParosN`, {
    //         method: 'POST',
    //         body: JSON.stringify(data),
    //         headers: {
    //             authorization: `Bearer ${tokenR.current}`,
    //             Accept: 'application/json',
    //             'Content-Type': 'application/json',
    //         },
    //     });

    //     const respuesta = await res.json();
    //     if (res.status === 200) {
    //         let datos = [];
    //         let area, nombreParo, fechaFin;
    //         let contador = 0;

    //         // if (llamadas.length !== 0) {
    //         respuesta.map((respu) => {
    //             let areaYNombre = llamadas.find((llamada) => llamada.tipoLlamada === respu.estatus);
    //             if (areaYNombre === undefined || areaYNombre.tipoLlamada === 10) {
    //                 nombreParo = 'Paro';
    //                 area = 5;
    //                 contador++;
    //             } else {
    //                 nombreParo = areaYNombre.nombre;
    //                 area = areaYNombre.color;
    //             }

    //             if (respu.fechaHoraFin === null) {
    //                 fechaFin = null;
    //             } else {
    //                 fechaFin =
    //                     respu.fechaHoraFin.slice(0, 10) + ' ' + respu.fechaHoraFin.slice(11, 19);
    //             }

    //             datos.push({
    //                 id: respu.folio,
    //                 duracion: respu.duracion.slice(0, 8),
    //                 estatus: respu.estatus,
    //                 fechaHoraFin: fechaFin,
    //                 fechaHoraIni:
    //                     respu.fechaHoraIni.slice(0, 10) + ' ' + respu.fechaHoraIni.slice(11, 19),
    //                 folio: respu.folio,
    //                 nombre: nombreParo,
    //                 area: area,
    //                 celda: respu.celda,
    //                 nombreCelda: respu.nombre,
    //             });
    //         });
    //         setNotify(contador);
    //         setParos(datos);
    //         setIsLoadingTable(false);
    //         // }
    //     }
    // };

    // Necesaria para hacer debug, se debe comentar la de arriba
    
    const getParos = useCallback(async () => {
        const data = {
            celda: celda,
            cantHoras: intervalo,
        };
    
        const res = await fetch(`${process.env.REACT_APP_SERVICE_ENDPOINT_NE}/Paros/GetParosN`, {
            method: 'POST',
            body: JSON.stringify(data),
            headers: {
                authorization: `Bearer ${tokenR.current}`,
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
        });

        if (!res.ok) return;
        const respuesta = await res.json();
        if (res.status === 200) {
            let datos = [];
            let area, areaNombre, color, nombreParo, fechaFin;
            let contador = 0;

            respuesta.forEach((respu) => {
                let areaYNombre = llamadas.find((llamada) => llamada.tipoLlamada === respu.estatus);
                if (areaYNombre === undefined || areaYNombre.tipoLlamada === 10) {
                    nombreParo = 'Paro';
                    area = null;
                    areaNombre = '';
                    color = null;
                    contador++;
                } else {
                    // La inicial del badge sale del área de atención y su color del
                    // catálogo de colores de la llamada: son campos independientes
                    nombreParo = areaYNombre.nombre;
                    area = areaYNombre.areaAtencion;
                    areaNombre = areaYNombre.areaAtencionName;
                    color = areaYNombre.color;
                }
    
                if (respu.fechaHoraFin === null) {
                    fechaFin = null;
                } else {
                    fechaFin = `${respu.fechaHoraFin.slice(0, 10)} ${respu.fechaHoraFin.slice(11, 19)}`;
                }
    
                datos.push({
                    id: respu.folio,
                    duracion: respu.duracion.slice(0, 8),
                    estatus: respu.estatus,
                    fechaHoraFin: fechaFin,
                    fechaHoraIni: `${respu.fechaHoraIni.slice(0, 10)} ${respu.fechaHoraIni.slice(11, 19)}`,
                    folio: respu.folio,
                    nombre: nombreParo,
                    area: area,
                    areaNombre: areaNombre,
                    color: color,
                    celda: respu.celda,
                    nombreCelda: respu.nombre,
                });
            });
    
            setNotify(contador);
            setParos(datos);
            setIsLoadingTable(false);
        }
    }, [celda, intervalo, llamadas, tokenR, setNotify, setParos, setIsLoadingTable]);
    

    // const getStatusLinea = async () => {
    //     const cookie = new Cookies();
    //     const data = {
    //         celda: celda,
    //         cantHoras: intervalo,
    //     };

    //     const res = await fetch(`${process.env.REACT_APP_SERVICE_ENDPOINT_NE_NE}/api/Paros/GetEstatusLinea`, {
    //         method: 'POST',
    //         body: JSON.stringify(data),
    //         headers: {
    //             authorization: `Bearer ${tokenR.current}`,
    //             Accept: 'application/json',
    //             'Content-Type': 'application/json',
    //         },
    //     });

    //     const respuesta = await res.json();
    //     if (res.status === 200) {
    //         let estLinea = [];
    //         let nEstatus;

    //         if (respuesta.estatusLinea.length !== 0) {
    //             respuesta.estatusLinea.map((resp) => {
    //                 if (resp.estatus === 0) {
    //                     nEstatus = 'Fuera de Operacion';
    //                 } else if (resp.estatus === 1) {
    //                     nEstatus = 'Operando';
    //                 } else if (resp.estatus === 2) {
    //                     nEstatus = 'Setup';
    //                 } else if (resp.estatus === 3) {
    //                     nEstatus = 'Purga';
    //                 } else if (resp.estatus === 4) {
    //                     nEstatus = 'Purga y Lavado';
    //                 } else if (resp.estatus === 5) {
    //                     nEstatus = 'Paro planeado';
    //                 } else if (resp.estatus === 7) {
    //                     nEstatus = 'Sin Material';
    //                 } else if (resp.estatus === 8) {
    //                     nEstatus = 'Atasco de Línea';
    //                 } else if (resp.estatus === 6 || resp.estatus >= 9) {
    //                     let nombreE = llamadas.find(
    //                         (llamada) => llamada.tipoLlamada === resp.estatus
    //                     );
    //                     if (nombreE === undefined || nombreE.tipoLlamada === 10) {
    //                         nEstatus = 'Paro';
    //                     } else {
    //                         nEstatus = nombreE.nombre;
    //                     }
    //                 }

    //                 estLinea.push({
    //                     folio: resp.folio,
    //                     estatus: resp.estatus,
    //                     nombreEstatus: nEstatus,
    //                     fechaHoraFin: resp.fechaHoraFin,
    //                     fechaHoraIni: resp.fechaHoraIni,
    //                 });
    //             });
    //         }
    //         if (respuesta.parosProgramados.length !== 0) {
    //             respuesta.parosProgramados.map((parosP) => {
    //                 estLinea.push({
    //                     folio: null,
    //                     estatus: 5,
    //                     nombreEstatus: parosP.descripcion,
    //                     fechaHoraFin: parosP.fechaHoraFin,
    //                     fechaHoraIni: parosP.fechaHoraIni,
    //                 });
    //             });
    //         }

    //         setStatusLinea(estLinea);
    //     }
    // };

    // Necesaria para hacer debug, se debe comentar la de arriba
    
    const getStatusLinea = useCallback(async () => {
        if (statusLineaFetchingRef.current) return;
        statusLineaFetchingRef.current = true;

        const data = {
            celda: celda,
            cantHoras: intervalo,
        };

        try {
            const res = await fetch(`${process.env.REACT_APP_SERVICE_ENDPOINT_NE}/Paros/GetEstatusLinea`, {
                method: 'POST',
                body: JSON.stringify(data),
                headers: {
                    authorization: `Bearer ${tokenR.current}`,
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                },
            });

            if (!res.ok) return;
            const respuesta = await res.json();
            let estLinea = [];
            if (respuesta.estatusLinea.length !== 0) {
                respuesta.estatusLinea.forEach((resp) => {
                    let nEstatus = 'Paro';
                    if (resp.estatus < 0) {
                        // Los paros autorizados tienen catálogo propio y su código ya viene negativo
                        const paro = parosAutRef.current.find(
                            (p) => Number(p.codigo) === resp.estatus
                        );
                        nEstatus = paro ? paro.nombre : 'Paro autorizado';
                    } else if (resp.estatus === 0) {
                        nEstatus = 'Fuera de Operacion';
                    } else if (resp.estatus === 1) {
                        nEstatus = 'Operando';
                    } else if (resp.estatus === 2) {
                        nEstatus = 'Setup';
                    } else if (resp.estatus === 3) {
                        nEstatus = 'Purga';
                    } else if (resp.estatus === 4) {
                        nEstatus = 'Purga y Lavado';
                    } else if (resp.estatus === 5) {
                        nEstatus = 'Paro planeado';
                    } else if (resp.estatus === 7) {
                        nEstatus = 'Sin Material';
                    } else if (resp.estatus === 8) {
                        nEstatus = 'Atasco de Línea';
                    } else if (resp.estatus === 6 || resp.estatus >= 9) {
                        let nombreE = llamadas.find(
                            (llamada) => llamada.tipoLlamada === resp.estatus
                        );
                        if (nombreE === undefined || nombreE.tipoLlamada === 10) {
                            nEstatus = 'Paro';
                        } else {
                            nEstatus = nombreE.nombre;
                        }
                    }

                    estLinea.push({
                        folio: resp.folio,
                        estatus: resp.estatus,
                        nombreEstatus: nEstatus,
                        fechaHoraFin: resp.fechaHoraFin,
                        fechaHoraIni: resp.fechaHoraIni,
                    });
                });
            }
            // Solo actualizar el estado si la data realmente cambió, para no
            // redibujar la gráfica y la tabla en cada ciclo de polling
            const estLineaJson = JSON.stringify(estLinea);
            if (estLineaJson !== lastStatusLineaJsonRef.current) {
                lastStatusLineaJsonRef.current = estLineaJson;
                setStatusLinea(estLinea);
            }
        } catch (error) {
            // Error de red: se reintenta en el siguiente ciclo de polling
        } finally {
            statusLineaFetchingRef.current = false;
        }
    }, [celda, intervalo, llamadas, tokenR, setStatusLinea]);

    
    const filtrarCeldas = useCallback((cells) => {
        const cookie = new Cookies();
        const celdasF = [];

        cells.forEach((cell) => {
            if (cell.linea === parseInt(cookie.get('linea'))) {
                celdasF.push(cell);
            }
        });

        setCeldas(celdasF);
    }, [setCeldas]);

    const getCeldas = useCallback(async () => {
        const data = await fetch(`${process.env.REACT_APP_SERVICE_ENDPOINT_NE}/celdas`, {
            method: 'GET',
            headers: {
                authorization: `Bearer ${tokenR.current}`,
                Accept: 'application/json',
            },
        });
    
        const celdas = await data.json();
        if (data.status === 200) {
            if (celdas.length > 0) {
                filtrarCeldas(celdas);
            }
        }
    }, [tokenR, filtrarCeldas]);

    const realiLlamada = useCallback(async () => {
        // Bloqueo síncrono: si ya hay una llamada en curso, ignorar el nuevo disparo.
        // Se usa un ref (no el estado) porque se actualiza al instante y frena los
        // clics rápidos en sucesión antes de que React re-renderice.
        if (callInProgressRef.current) return;
        callInProgressRef.current = true;
        setCallInProgress(true);

        const cookie = new Cookies();

        try {
            if (selectedRow !== null) {
                const reasignarData = {
                    ...selectedRow.data,
                    tipoLlamada: idParo,
                };

                const reasignarRes = await fetch(
                    `${process.env.REACT_APP_SERVICE_ENDPOINT_NE}/Llamadas/ReasignarLlamada`,
                    {
                        method: 'POST',
                        body: JSON.stringify(reasignarData),
                        headers: {
                            authorization: `Bearer ${tokenR.current}`,
                            Accept: 'application/json',
                            'Content-Type': 'application/json',
                        },
                    }
                );

                const reasignarRespuesta = await reasignarRes.json();

                if (reasignarRes.status === 200) {
                    selectedRow.callback();
                    setOpenConf(false);
                    getParos();
                } else {
                    console.error('Error en ReasignarLlamada:', reasignarRespuesta);
                }
            } else {
                const realizarData = {
                    celda: parseInt(cookie.get('celda')),
                    tipoLlamada: idParo,
                    solicita: cookie.get('usuario'),
                };

                const realizarRes = await fetch(
                    `${process.env.REACT_APP_SERVICE_ENDPOINT_NE}/Llamadas/RealizarLlamada`,
                    {
                        method: 'POST',
                        body: JSON.stringify(realizarData),
                        headers: {
                            authorization: `Bearer ${tokenR.current}`,
                            Accept: 'application/json',
                            'Content-Type': 'application/json',
                        },
                    }
                );

                if (!realizarRes.ok) return;
                const realizarRespuesta = await realizarRes.json();

                if (realizarRes.status === 200) {
                    // Optimistic update: insertar la llamada inmediatamente sin esperar getParos()
                    const areaYNombre = llamadas.find((l) => l.tipoLlamada === idParo);
                    const nombreParo = areaYNombre ? areaYNombre.nombre : 'Paro';
                    const area = areaYNombre ? areaYNombre.areaAtencion : null;
                    const areaNombre = areaYNombre ? areaYNombre.areaAtencionName : '';
                    const color = areaYNombre ? areaYNombre.color : null;
                    const now = new Date().toISOString();
                    const fechaHoraIni = `${now.slice(0, 10)} ${now.slice(11, 19)}`;
                    const tempId = Date.now();
                    setParos((prev) => [
                        ...prev,
                        {
                            id: tempId,
                            folio: tempId,
                            duracion: '00:00:00',
                            estatus: idParo,
                            fechaHoraFin: null,
                            fechaHoraIni: fechaHoraIni,
                            nombre: nombreParo,
                            area: area,
                            areaNombre: areaNombre,
                            color: color,
                            celda: celda,
                            nombreCelda: '',
                        },
                    ]);
                    setMensaje('Llamada creada satisfactoriamente');
                    setTipoMensaje('success');
                    setOpenSnack(true);
                    setOpenConf(false);
                    // Sincronizar con el servidor para reemplazar el registro temporal
                    getParos();
                } else {
                    console.error('Error en RealizarLlamada:', realizarRespuesta);
                }
            }
        } catch (error) {
            console.error('Error en realiLlamada:', error);
        } finally {
            // Liberar el bloqueo siempre, tanto en éxito como en error.
            callInProgressRef.current = false;
            setCallInProgress(false);
        }
    }, [idParo, selectedRow, getParos, llamadas, celda, setParos]);


    // const actualizarParo = async () => {
    //     const data = {
    //         folio: folio,
    //         Estatus: idParo,
    //     };

    //     const res = await fetch(`${process.env.REACT_APP_SERVICE_ENDPOINT_NE_NE}/api/Paros/PutCategoriaParo`, {
    //         method: 'PUT',
    //         body: JSON.stringify(data),
    //         headers: {
    //             authorization: `Bearer ${tokenR.current}`,
    //             Accept: 'application/json',
    //             'Content-Type': 'application/json',
    //         },
    //     });

    //     const respuesta = await res.text();

    //     if (res.status === 200) {
    //         setMensaje('Paro categorizado satisfactoriamente');
    //         setTipoMensaje('success');
    //         setOpenConf(false);
    //         setOpenSnack(true);
    //         getParos();
    //         getStatusLinea();
    //     }
    // };

    // Necesaria para hacer debug, se debe comentar la de arriba

    const actualizarParo = useCallback(async () => {
        const data = {
            folio: folio,
            Estatus: idParo,
        };
    
        const res = await fetch(
            `${process.env.REACT_APP_SERVICE_ENDPOINT_NE}/Paros/PutCategoriaParo`,
            {
                method: 'PUT',
                body: JSON.stringify(data),
                headers: {
                    authorization: `Bearer ${tokenR.current}`,
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                },
            }
        );
    
        if (res.status === 200) {
            setMensaje('Paro categorizado satisfactoriamente');
            setTipoMensaje('success');
            setOpenConf(false);
            setOpenSnack(true);
            getParos();
            getStatusLinea();
        }
    }, [folio, idParo, tokenR, getParos, getStatusLinea]);
    

    const setActiveRow = useCallback((row) => {
        setSelectedRow(row);
    }, []);

    const handleClickB = useCallback((colorB, colorS, textC, tipo, categoria,rowData=null) => {
        setColorB(colorB);
        let result = [];
        if (tipo === 0) {
            result = llamadas.filter((llamada) => llamada.colorName === colorS);
            setMensajeConf('reportar el problema ');
        } else {
            result = llamadas.filter(
                (llamada) => llamada.colorName === colorS && llamada.esDowntime === true
            );
            setMensajeConf('categorizar el paro como ');
        }

        setIsCall(tipo);
        setLamada(result);
        setColorT(colorS);
        setTextC(textC);
        setOpenP(false);
        setOpenM(true);
        setCatego(categoria);
        setActiveRow(rowData);
    }, [llamadas, setActiveRow]);

    const updateParo = useCallback((paro) => {
        setSelectParo(paro.nombre);
        setIdParo(paro.tipoLlamada);
        setOpenM(false);
        setOpenConf(true);
    }, [setSelectParo, setIdParo, setOpenM, setOpenConf]);

    const setLlamada = useCallback((llamada) => {
        setSelectParo(llamada.nombre);
        setIdParo(llamada.tipoLlamada);
        setOpenM(false);
        setOpenConf(true);
    }, [setSelectParo, setIdParo, setOpenM, setOpenConf]);

    const getEnum = useCallback(async () => {
        const data1 = await fetch(
            `${process.env.REACT_APP_SERVICE_ENDPOINT_NE}/MicroServiciosController?categoria=AreasAtencion`,
            {
                method: 'GET',
                headers: {
                    authorization: `Bearer ${tokenR.current}`,
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                },
            }
        );

        const values1 = await data1.json();

        if (data1.status !== 400) {
            setAreas(values1);
        }
    }, []);

    const getUltimaEstiba = useCallback(async (corridaA) => {
        const cookie = new Cookies();
        const data = {
            corrida: corridaA,
            linea: parseInt(cookie.get('linea')),
        };
        const inforUE = await fetch(
            `${process.env.REACT_APP_SERVICE_ENDPOINT_NE}/Corridas/SolicitarFinCorrida`,
            {
                method: 'POST',
                body: JSON.stringify(data),
                headers: {
                    authorization: `Bearer ${tokenR.current}`,
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                },
            }
        );

        const respuesta = await inforUE.json();

        if (inforUE.status !== 400) {
            setInfoUE(respuesta);
            const modo = respuesta.modoCierre ?? 2;
            setModoCierre(modo);
            if (modo === 0) {
                setOpenC(true);
            } else if (modo === 1) {
                setOpenScrap(true);
            } else {
                setOpenUE(true);
            }
        }
    }, [tokenR, setInfoUE, setOpenUE, setOpenC, setModoCierre, setOpenScrap]);

    const getCorridaActiva = useCallback(async () => {
        const cookie = new Cookies();
        const tokenObj = JSON.parse(sessionStorage.getItem('token'));

        if (!tokenObj?.token) return;

        const data = await fetch(
            `${process.env.REACT_APP_SERVICE_ENDPOINT_NE}/PisoOrdenes/GetCorridaActiva?linea=${parseInt(cookie.get('linea'))}`,
            {
                method: 'GET',
                headers: {
                    authorization: `Bearer ${tokenObj.token}`,
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                },
            }
        );

        const corridaA = await data.json();
        if (data.status === 200) {
            getUltimaEstiba(corridaA);
        }
    }, [getUltimaEstiba]);

    // Inicializar refs directamente con las funciones
    getParosRef.current = getParos;
    getStatusLineaRef.current = getStatusLinea;
    getEnumRef.current = getEnum;
    getLlamadasRef.current = getLlamadas;
    getCeldasRef.current = getCeldas;
    handleClickBRef.current = handleClickB;
    isModalOpenRef.current = openM || openP || openConf;

    useEffect(() => {
        const hasToken = JSON.parse(sessionStorage.getItem('token'));
        if (!hasToken || generalContextInitializedRef.current) return;

        generalContextInitializedRef.current = true;
        llamadasCeldasInitializedRef.current = true;
        getLlamadas();
        getParosAutorizados();
        getCeldas();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []); // Ejecutar solo una vez al montar

    useEffect(() => {
        const hasToken = JSON.parse(sessionStorage.getItem('token'));
        if (!hasToken) return;

        const isFirstTime = lastCeldaRef.current === null;
        const celdaChanged = lastCeldaRef.current !== null && lastCeldaRef.current !== celda;
        const intervaloChanged = lastIntervaloRef.current !== null && lastIntervaloRef.current !== intervalo;
        const shouldExecute = (isFirstTime && !generalContextServicesInitializedRef.current) ||
                              (generalContextServicesInitializedRef.current && (celdaChanged || intervaloChanged));

        if (!shouldExecute) return;

        generalContextServicesInitializedRef.current = true;
        servicesInitializedRef.current = true;
        parosStatusInitializedRef.current = true;
        lastCeldaRef.current = celda;
        lastIntervaloRef.current = intervalo;
        
        setParos([]);
        // Clientes sin registro de paros no consultan paros ni estatus de línea.
        if (process.env.REACT_APP_ALLOW_PAROS_VIEW !== 'false') {
            getParos();
            getStatusLinea();
        }
        getEnum();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [intervalo, celda]); // Solo depender de intervalo y celda

    useEffect(() => {
        const hasToken = JSON.parse(sessionStorage.getItem('token'));
        if (!hasToken || !isInParosView) return;

        if (getParosRef.current) getParosRef.current();
        if (getStatusLineaRef.current) getStatusLineaRef.current();
        if (getEnumRef.current) getEnumRef.current();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isInParosView]);

    useEffect(() => {
        if (isInParosView === true && openP === false && openM === false && openConf === false) {
            interval1.current = setInterval(() => {
                if (getLlamadasRef.current) getLlamadasRef.current();
                if (getCeldasRef.current) getCeldasRef.current();
                if (getParosRef.current) getParosRef.current();
                if (getStatusLineaRef.current) getStatusLineaRef.current();
                if (getEnumRef.current) getEnumRef.current();
            }, 5000);
            return () => {
                clearInterval(interval1.current);
            };
        }
        if (openP === true || openM === true || openConf === true) {
            clearInterval(interval1.current);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isInParosView, openP, openM, openConf]); // No incluir funciones en dependencias, usar refs

    // Polling global para mantener el badge de notify actualizado desde cualquier vista
    useEffect(() => {
        const hasToken = JSON.parse(sessionStorage.getItem('token'));
        if (!hasToken || isInParosView || process.env.REACT_APP_ALLOW_PAROS_VIEW === 'false') return;

        const globalInterval = setInterval(() => {
            if (getParosRef.current) getParosRef.current();
        }, 30000);

        return () => clearInterval(globalInterval);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isInParosView]);

    useEffect(() => {
        const hasToken = JSON.parse(sessionStorage.getItem('token'));
        if (!hasToken || !llamadas || llamadas.length === 0) return;
        
        const lengthChanged = llamadas.length !== lastLlamadasLengthRef.current;
        const isFirstInitialization = lastLlamadasLengthRef.current === 0;
        
        if (isFirstInitialization) {
            lastLlamadasLengthRef.current = llamadas.length;
            return;
        }
        
        if (lengthChanged && generalContextServicesInitializedRef.current && process.env.REACT_APP_ALLOW_PAROS_VIEW !== 'false') {
            lastLlamadasLengthRef.current = llamadas.length;
            setParos([]);
            getParos();
            getStatusLinea();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [llamadas]); // Solo depender de llamadas

    useEffect(() => {
        if (terminarCorrida === true) {
            getCorridaActiva();
            setTerminarCorrida(false);
        }
    }, [getCorridaActiva, terminarCorrida]);

    // Hub Botón ANDON físico: siempre escuchando mientras haya sesión activa.
    // Cuando el dispositivo IIoT presiona el botón físico, el backend emite el color
    // y el frontend abre el menú ANDON correspondiente.
    useEffect(() => {
        const hasToken = JSON.parse(sessionStorage.getItem('token'));
        if (!hasToken || process.env.REACT_APP_ALLOW_WEBSOCKETS === 'false') return;

        // La vista TV tiene su propio hub (HubNovaEngineTelevisor). El hub ANDON
        // solo es relevante en el panel principal, no en la vista televisor.
        if (window.location.hash.startsWith('#/tv')) return;

        const cookie = new Cookies();
        const celdaId = parseInt(cookie.get('celda'));

        const apiBase = process.env.REACT_APP_SERVICE_ENDPOINT_NE || '';
        const hubUrl = apiBase.replace('/api', '/HubNovaEngine');

        if (!hubUrl) return;

        const BOTON_MAP = {
            1: { colorB: '#00a375', colorS: 'Verde',    textC: '#C9FFEF', categoria: 'Producción'    },
            2: { colorB: '#dd1717', colorS: 'Rojo',     textC: '#FCCACD', categoria: 'Mantenimiento' },
            3: { colorB: '#ffc800', colorS: 'Amarillo', textC: '#3D3207', categoria: 'Almacén'       },
            4: { colorB: '#0000FF', colorS: 'Azul',     textC: '#F2F4F8', categoria: 'Calidad'       },
        };

        let aborted = false;

        const connection = new HubConnectionBuilder()
            .withUrl(hubUrl, { skipNegotiation: true, transport: HttpTransportType.WebSockets })
            .withAutomaticReconnect()
            .build();

        connection.on('RecibirBotonAndon', (payload) => {
            const config = BOTON_MAP[payload?.Tipo];
            if (!config) return;
            // Si hay un modal abierto, cerrarlo antes de abrir el nuevo
            if (isModalOpenRef.current) {
                setOpenM(false);
                setOpenConf(false);
                setOpenP(false);
            }
            if (handleClickBRef.current) {
                handleClickBRef.current(config.colorB, config.colorS, config.textC, 0, config.categoria);
            }
        });

        connection.onreconnected(() => {
            connection.invoke('SuscribirBotonAndon', celdaId.toString()).catch(() => {});
        });

        connection.start()
            .then(() => {
                if (aborted) { connection.stop(); return; }
                connection.invoke('SuscribirBotonAndon', celdaId.toString()).catch(() => {});
            })
            .catch(() => {});

        return () => {
            aborted = true;
            connection.stop();
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // Sincronizar tokenR con el token actual al montar
    useEffect(() => {
        tokenR.current = token;
    }, [token]);

    // Renovación automática del token — silenciosa, con retry y Page Visibility API
    useTokenRenewal({
        tokenRef: tokenR,
        setToken,
        endpoint: process.env.REACT_APP_SERVICE_ENDPOINT_NE,
    });

    // Roles del usuario: se leen del JWT (claim ClaimTypes.Role, robusto ante
    // reload porque el token persiste). Fallback a infoUser.roles (GetUsuario).
    const roles = useMemo(() => {
        const fromToken = getRolesFromToken(token);
        if (fromToken.length) return fromToken;
        return Array.isArray(infoUser?.roles) ? infoUser.roles : [];
    }, [token, infoUser]);

    // Punto único de gating por rol para vistas (menú y router).
    const hasAccess = useCallback((viewId) => canAccessView(viewId, roles), [roles]);

    const generalValues = useMemo(() => {
        return {
            infoUser,
            setInfoUser,
            roles,
            hasAccess,
            openM,
            setOpenM,
            openP,
            setOpenP,
            handleClickB,
            realiLlamada,
            callInProgress,
            colorB,
            llamada,
            colorT,
            textC,
            openSnack,
            setOpenSnack,
            mensaje,
            setMensaje,
            tipoMensaje,
            setTipoMensaje,
            isCall,
            setIsCall,
            updateParo,
            openConf,
            setOpenConf,
            selectParo,
            setSelectParo,
            setLlamada,
            mensajeConf,
            setMensajeConf,
            catego,
            setCatego,
            actualizarParo,
            folio,
            setFolio,
            notify,
            setNotify,
            paros,
            setParos,
            intervalo,
            setIntervalo,
            isLoading,
            setIsLoading,
            statusLinea,
            setStatusLinea,
            loadingTable,
            setActiveRow,
            setIsLoadingTable,
            celdas,
            setCeldas,
            celda,
            setCelda,
            openC,
            setOpenC,
            confirm,
            setConfirm,
            confirmIni,
            setConfirmIni,
            openIni,
            setOpenIni,
            inParosView,
            setInParosView,
            areas,
            setAreas,
            openIniEsp,
            setOpenIniEsp,
            confirmIniEsp,
            setConfirmIniEsp,
            openTermEsp,
            setOpenTermEsp,
            confirmTermEsp,
            setConfirmTermEsp,
            tokenR,
            isInParosView,
            setIsInParosView,
            setOpenUE,
            openUE,
            infoUE,
            setTerminarCorrida,
            difCajas,
            setDifCajas,
            modoCierre,
            openScrap,
            setOpenScrap,
            scrapData,
            setScrapData,
            getStatusLinea,
        };
    }, [infoUser, setInfoUser, roles, hasAccess, openM, setOpenM, openP, setOpenP, handleClickB, colorB, llamada, colorT, textC, realiLlamada, callInProgress, openSnack, setOpenSnack, mensaje, setMensaje, tipoMensaje, setTipoMensaje, isCall, setIsCall, updateParo, openConf, setOpenConf, selectParo, setSelectParo, setLlamada, mensajeConf, setMensajeConf, catego, setCatego, actualizarParo, folio, setFolio, notify, setNotify, paros, setParos, intervalo, setIntervalo, isLoading, setIsLoading, statusLinea, setStatusLinea, loadingTable, setIsLoadingTable, celdas, setCeldas, celda, setCelda, openC, setOpenC, confirm, setConfirm, confirmIni, setConfirmIni, openIni, setOpenIni, inParosView, setInParosView, areas, setAreas, openIniEsp, setOpenIniEsp, confirmIniEsp, setConfirmIniEsp, openTermEsp, setOpenTermEsp, confirmTermEsp, setConfirmTermEsp, tokenR, isInParosView, setIsInParosView, setOpenUE, openUE, infoUE, setTerminarCorrida, difCajas, setDifCajas, modoCierre, openScrap, setOpenScrap, scrapData, setScrapData, getStatusLinea, setActiveRow]);

    return <GeneralContext.Provider value={generalValues} {...props} />;
}

export function useGeneral() {
    const context = useContext(GeneralContext);
    if (!context) {
        throw new Error('useGeneral debe estar dentro del proveedor GeneralContext');
    }
    return context;
}
